// extracted by mini-css-extract-plugin
export default {"melodyVideo":"fJ-z","isFullWidth":"gJ-z","landingPageVideo":"hJ-z","play":"iJ-z","iframeVideo":"jJ-z","playHidden":"kJ-z","fullwidth":"lJ-z"};